import * as React from 'react';
import {
  Logging,
  UserInfo,
  PermissionGroup,
  UserContext,
  getViewPermission,
} from '@vcd-ecm-ui/Common';
import { VtxTabPane, VtxTabs } from '@vertexinc/vtx-ui-react-component-library';
import CustomerViewTabsProps from './CustomerViewTabsProps.interface';
import '../../customer-info.scss';
import CustomerGeneral from '../General/CustomerGeneral';
import CustomerContact from '../Contacts/CustomerContact';
import CustomerContacts from '../Contacts/CustomerContacts';
import CustomerExemptions from '../Exemptions/CustomerExemptions';
import CustomerChildren from '../Children/CustomerChildren';

const CustomerViewTabs = ({
  customer,
  selectedTab,
  hasParentCustomer,
  onSelectTab,
  gatewayEndPoint,
  onCertificateApproved,
  onCertificateEdited,
}: CustomerViewTabsProps): JSX.Element => {
  Logging.Debug('Customer Tabs:', selectedTab);

  const multipleContacts: boolean = customer.contacts ? customer.contacts.length > 1 : false;

  // Get the User Context
  const userContext: UserInfo = React.useContext(UserContext);

  // Get the Contacts View Permission
  const hasContactViewPermission: boolean = getViewPermission(userContext, PermissionGroup.Contacts);

  // Get the Contacts View Permission
  const hasCertificatesViewPermission: boolean = getViewPermission(userContext, PermissionGroup.Certificates);

  return (
    <div className="customerTabsContainer">
      <VtxTabs activeKey={selectedTab} onChange={onSelectTab}>
        <VtxTabPane tab="General" key="1">
          <CustomerGeneral
            customer={customer}
            gatewayEndPoint={gatewayEndPoint}
          />
        </VtxTabPane>
        {hasContactViewPermission && (
          <VtxTabPane tab="Contacts" key="2">
            {multipleContacts ? (
              <CustomerContacts
                customer={customer}
                hasParentCustomer={hasParentCustomer}
                gatewayEndPoint={gatewayEndPoint}
              />
            ) : (
              <CustomerContact customer={customer} />
            )}
          </VtxTabPane>
        )}
        {hasCertificatesViewPermission && (
          <VtxTabPane tab="Exemptions" key="3">
            <CustomerExemptions
              customer={customer}
              gatewayEndPoint={gatewayEndPoint}
              onCertificateApproved={onCertificateApproved}
              onCertificateEdited={onCertificateEdited}
            />
          </VtxTabPane>
        )}
        {
          !hasParentCustomer
          && (
            <VtxTabPane tab="Child Customers" key="4">
              <CustomerChildren customer={customer} gatewayEndPoint={gatewayEndPoint} />
            </VtxTabPane>
          )
        }
      </VtxTabs>
    </div>
  );
};

export default CustomerViewTabs;
